import { MicrosoftXboxControllerBatteryEmptyIcon } from './MicrosoftXboxControllerBatteryEmptyIcon';

/**
 * author: Austin Andrews
 * id 51BB7455-5893-4F47-92D1-B3FD408C2ADC
 * name microsoft-xbox-controller-battery-empty
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller-battery-empty.svg
 * tags
 * - Battery 
 * - Gaming / RPG 
 */
export const MicrosoftXboxGamepadBatteryEmptyIcon = MicrosoftXboxControllerBatteryEmptyIcon;
export default MicrosoftXboxGamepadBatteryEmptyIcon